import React from 'react';
import { withTranslation } from 'react-i18next';
import { YcPerson } from '@/components';

// styles
import './ycHistory.scss';
// styles

export const YcHistory = withTranslation(['about-us'])(
  class YcHistoryClass extends React.PureComponent {
    experiences = ['bank', 'computer', 'tradespeople', 'book-keeper', 'contributors'];
    trades = ['web', 'import-export', 'rental', 'real-estate', 'breweries'];

    render() {
      const { t } = this.props;

      return (
        <div className="page-projects__block page-projects__block-expert">
          <div className="page-projects__block__image">
            <div className="person-container">
              <YcPerson person="jc" className="image_jc" />
              <YcPerson person="lucas" className="image_lucas" />
            </div>
          </div>

          <div className="page-projects__block__text">
            <div className="box">
              <h2 dangerouslySetInnerHTML={{ __html: t('about-us.history.main-title') }} />
              <h3 dangerouslySetInnerHTML={{ __html: t('about-us.history.subtitle') }} />
              <p className="desc" dangerouslySetInnerHTML={{ __html: t('about-us.history.desc') }} />
            </div>
          </div>
        </div>
      );
    }
  },
);
